import { render, staticRenderFns } from "./HeroV2.vue?vue&type=template&id=6de9d366&scoped=true&"
import script from "./HeroV2.vue?vue&type=script&lang=ts&"
export * from "./HeroV2.vue?vue&type=script&lang=ts&"
import style0 from "./HeroV2.vue?vue&type=style&index=0&id=6de9d366&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6de9d366",
  null
  
)

export default component.exports